import React from "react";

import ArrowLeft from "../../Icons/ArrowLeftShape";
import SquareButton from "../SquareButton";

import styles from "./SearchFilterMenu.module.scss";
import GroupList from "../../GroupList/GroupList";
import type { GroupListFieldType, GroupListItem } from "../../GroupList/GroupList";

interface SearchFilterMenuProps {
    title: string;
    items: GroupListItem[];
    fieldType: GroupListFieldType,
    onCheckboxChange?: (listItem: GroupListItem) => void;
    onClose: () => void;
    onClear?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent> | undefined) => void;
    onSave?: () => void;
}

/**
 * Search Filter Button
 */
const SearchFilterMenu = (props: SearchFilterMenuProps) => {
    const {
        title,
        items,
        fieldType,
        onCheckboxChange,
        onClose,
        onClear = () => { },
        onSave
    } = props;

    const handleEscape = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === "Escape") {
            onClose();
        }
    };

    const handleSaveClick = () => {
        onSave?.();
        onClose();
    };

    return (
        <div
            className={styles.container}
            role="presentation"
            onKeyUp={handleEscape}
        >
            <button
                type="button"
                className={styles.backButton}
                onClick={handleSaveClick}
            >
                <span className={styles.labelContainer}>
                    <ArrowLeft className={styles.labelIcon} />
                    <span className={styles.labelBody}>All Filters</span>
                </span>
            </button>
            <div className={styles.listContainer}>
                <GroupList
                    title={title}
                    items={items}
                    fieldType={fieldType}
                    onCheckboxChange={onCheckboxChange}
                />
            </div>
            <footer className={styles.footer}>
                <SquareButton
                    color="outline"
                    className={styles.clearButton}
                    onClick={onClear}
                >
                    Clear
                </SquareButton>
                <SquareButton
                    color="secondary-100"
                    className={styles.saveButton}
                    onClick={handleSaveClick}
                >
                    Save
                </SquareButton>
            </footer>
        </div>
    );
};

export { SearchFilterMenu as default };
export type { SearchFilterMenuProps };
